
import { fetchService } from '../Utility/Fetch.service';
import { Config } from '../Config/Config';

import {store} from '../reducers/index';
import { Utility } from '../Utility/Utility';

export const userActions = {
    login,
    VerifyExternalUser,
    VerifyOTP,
    RequestActivityList,
    RequestStudentList,
    SubmitCourseActivity,
    GetAppsRubric,
    GetStudentStatus,
    GetAllStudentResult,
    SubmitRubricMarking,
    OLELogout,
    getLtpaTokenUserNameIfValid,
    SubmitLogBook,
};

//normal user login
function login(username,password,noClear=false){
    store.dispatch({type:'SET_USERLTPATOKEN',payload:''})
    username=username.toLowerCase();

    return fetchService.loginByOle(username,password).then(
        async (res)=>{
            if(!res){ 
                if (!noClear){
                    store.dispatch({type:'SET_ISOLEACCOUNT',payload:false})                   
                }
                return Promise.resolve(false);
            }else {
                let data={username:username,password:password};
                
                store.dispatch({type:'SET_ISOLEACCOUNT',payload:true})
                //await dispatch(getUserInfo(username));
                store.dispatch({
                    type: 'SET_USERNAME_PASSWORD_AFTER_LOGIN',    
                    payload:data
                });
            
                return Promise.resolve(true);
            }
        },
        (error)=>{
            console.log(JSON.stringify(error));
            console.log(error);
            /*dispatch({
                type: userConstants.LOGOUT_WITHOUT_CLEAR,
                payload:{}
            });*/
            return Promise.reject(false);
        }
    )
}


//Request OTP
//Para : email
//respone : result,message
function VerifyExternalUser(email){
    store.dispatch({type:'SET_USERLTPATOKEN',payload:''})
    console.log('VerifyExternalUser');
    let formBody = [];
    let dataToSend = {email: email};
    for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    return fetchService.callbypost(Config.VERIFY_EXTERNAL_USER,
        {
            body: formBody,

        },{}).then(
        (res)=>{
            console.log("VerifyExternalUser:",res);
            if(res.result){
                store.dispatch({type:'SAVE_USERNAME',payload:email});
                //store.dispatch({type:userConstants.SET_USERNAME,payload:email});
                return Promise.resolve(res);    
            }else {
                return Promise.resolve(res);    
            }
        },
        (error)=>{
            console.log(error);
            /*dispatch({
                type: userConstants.LOGOUT_WITHOUT_CLEAR,
                payload:{}
            });*/
            return Promise.reject();
        }
    )
}

///Send OTP
//Para : email,verify_code
//respone : result,message
function VerifyOTP(email,OTP){

    console.log('Send OTP');
    let formBody = [];
    let dataToSend = {email: email, verify_code:OTP};
    for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    return fetchService.callbypost(Config.VERIFY_ACTIVATION_CODE,
        {
            body: formBody,

        },{}).then(
        (res)=>{
            console.log(res);
            if(res.result){
                store.dispatch({type:'SAVE_TOKEN',payload:res.token});
                //store.dispatch({type:userConstants.SET_USERNAME,payload:email});
                return Promise.resolve(res);    
            }else {
                return Promise.resolve(res);    
            }
        },
        (error)=>{
            console.log(error);
            /*dispatch({
                type: userConstants.LOGOUT_WITHOUT_CLEAR,
                payload:{}
            });*/
            return Promise.reject();
        }
    )
}



///Get Activity List by Token
//Para : token
//Respone : result,(tutor,course_activity)/message
function RequestActivityList(){

    // console.log("Store:",store.getState().userInfo);
    var Token= store.getState().userInfo.token;
    // console.log("Token:",Token);

    let formBody = [];
    if (!store.getState().userInfo.isOLEaccount){
        let dataToSend = {token:Token};
        for (let key in dataToSend) {
          let encodedKey = encodeURIComponent(key);
          let encodedValue = encodeURIComponent(dataToSend[key]);
          formBody.push(encodedKey + '=' + encodedValue);
        }
    }
    formBody = formBody.join('&');
    // console.log("formBody at request Activity list: ",formBody);
    
    return fetchService.callbypost(Config.GET_ACTIVITY_LIST,
        {      

            body: formBody,
            
        },{}).then(
        (res)=>{
            console.log("Request Activity List by Token Result:",res);
            if(res.result){
                //store.dispatch({type:userConstants.SET_USERNAME,payload:email});
                return Promise.resolve(res);    
            }else {
                return Promise.resolve(res);    
            }
        },
        (error)=>{
            console.log(error);
            /*dispatch({
                type: userConstants.LOGOUT_WITHOUT_CLEAR,
                payload:{}
            });*/
            return Promise.reject();
        }
    )
}


///Request Student List by Course ID

function RequestStudentList(Course){

    const Token=(store.getState().userInfo.token);
    console.log("Request Student List by Token("+ Token +") and Course Activity:" + Course);
    let formBody = [];
    let dataToSend = {token:Token,course:Course,'gp':'ALL'};
    for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    // console.log("Request Student List by :" + formBody);
    return fetchService.callbypost(Config.GET_STUDENT_LIST,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formBody,
        },{}).then(
        (res)=>{
            console.log("RequestStudentList:",res);
            if(res.result){
                //store.dispatch({type:userConstants.SET_USERNAME,payload:email});
                return Promise.resolve(res);     
            }else {
                return Promise.resolve(res);    
            }
        },
        (error)=>{
            console.log(error);
            /*dispatch({
                type: userConstants.LOGOUT_WITHOUT_CLEAR,
                payload:{}
            });*/
            return Promise.reject();
        }
    )
}
function getLtpaTokenUserNameIfValid(){
    return fetchService.callbyget(Config.VERIFY_OLE_USER,{cache: 'no-store'}).then(
        (res)=>{
            // console.log(res);
            store.dispatch({type:'SET_USERINFOFROMOLE',payload:res});
            return Promise.resolve(res);
        },
        (error)=>{
            console.log(error)
            return Promise.resolve(error);
        }
    )
}
function SubmitCourseActivity(Course,Tmaid){
    const Token=(store.getState().userInfo.token);
    console.log("Submit Selected Course Activity "+ Course +";ID[" + Tmaid + "]");

    let formBody = [];
    let dataToSend = {token:Token,course:Course,tmaid:Tmaid};
    for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    return fetchService.callbypost(Config.SUBMIT_COURSE_ACTIVITY,
        {
            body: formBody,
        },{}).then(
        (res)=>{
            console.log(res);
            if(res.result){
                //store.dispatch({type:userConstants.SET_USERNAME,payload:email});
                return Promise.resolve(res);    
            }else {
                return Promise.resolve(res);    
            }
        },
        (error)=>{
            console.log(error);
            /*dispatch({
                type: userConstants.LOGOUT_WITHOUT_CLEAR,
                payload:{}
            });*/
            return Promise.reject();
        }
    )
}

// Submit Form
// !! marked = N for save Y for submit
function SubmitRubricMarking(markscore,markname,PlacementStartDate,PlacementEndDate,LeaveofAbsence,ClinicalEducationUnit,TutorRemark,StudentRemark,EducatorName,submit){

    const Token=(store.getState().userInfo.token);

    console.log();
    let Sid = store.getState().userInfo.selectedStudentID;
    // if(Sid.includes("s")){
    //     Sid = Utility.convertToUserId(Sid);
    // }
    if(!Sid.includes("s")){
        Sid = "s" + Sid;
    }

    if(Sid.length > 8){
        Sid = Sid.substring(0,8);
    }

    console.log("submit/save form with sid:",Sid);


    let Course = store.getState().userInfo.selectedCourse;
    let Tmaid = store.getState().userInfo.selectedCourseActivityID;
    
    //Hardcode = Devlopment Use
    //Tmaid = "SOFTSKILL1";

    let save = "N";
    if(submit){
        save = "Y";
    }

    // console.log("Submit Rubric Marking:Course"+ Course +";TID[" + Tmaid + "];S_ID" + Sid);

    let formBody = [];

    let dataToSend = {}
    let submitUrl='';

    // console.log("Save TutorName:",EducatorName);

     if(store.getState().userInfo.userType == "STAFF"){
        dataToSend = {
            token:Token,
            course:Course,
            tmaid:Tmaid,
            sid:Sid,
            placement_from : PlacementStartDate||'',
            placement_to : PlacementEndDate||'',
            leave_of_absence : LeaveofAbsence||0,
            education_unit : ClinicalEducationUnit||'',
            tutor_remark : TutorRemark == undefined ||  TutorRemark == "undefined" ? "" : TutorRemark,
            stu_remark : StudentRemark == undefined ||  StudentRemark == "undefined" ? "":StudentRemark,
            stu_name : store.getState().userInfo.selectedStudentName,
            // tutor_name : store.getState().userInfo.username,
            tutor_name : EducatorName,
            marked : save,
        }
        submitUrl=Config.SUBMIT_RUBRIC_MARKING;
     }else {
        submitUrl=Config.SUBMIT_RUBRIC_MARKING_STUDENT;

        dataToSend = {
            token:Token,
            course:Course,
            tmaid:Tmaid,
            sid:Sid,
            stu_remark : StudentRemark == undefined ||  StudentRemark == "undefined" ? "":StudentRemark,
            marked : save
        }
     }

        
    
    for (let key in dataToSend) {
        // let encodedKey = key;
        // let encodedValue = dataToSend[key];
        let encodedKey = encodeURIComponent(key);
        let encodedValue = encodeURIComponent(dataToSend[key]);

        formBody.push(encodedKey + '=' + encodedValue);
    }

    // for (let key in markscore) {
    //     let encodedKey = encodeURIComponent(key);
    //     let encodedValue = encodeURIComponent(markscore[key]);
    //     // console.log("markscore:" + encodedKey + "="+ encodedValue);
    //     if(encodedValue!=undefined){
    //         formBody.push(encodedKey + '=' + encodedValue);
    //     }
    // }

    //console.log("markscore:",markscore);

    if(store.getState().userInfo.userType == "STAFF"){
        for (let key in markname) {
            let encodedKey = encodeURIComponent(key);
            let encodedValue = encodeURIComponent(markname[key]);
            // console.log("markscore:" + encodedKey + "="+ encodedValue);
            let score = markscore[encodedKey];
            // console.log("score:" + score);
            if(score == undefined){
                score =-1;
            }
            // console.log("markname:" + encodedValue + "key:" + encodedKey + ";score="+ score);
            formBody.push(encodedKey + '=' + score);
        }
    }

    formBody = formBody.join('&');

    console.log("SubmitRubricMarking:",formBody);
    console.log('dataToSend',dataToSend)
    
    return fetchService.callbypost(submitUrl,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formBody,
        },{}).then(
        (res)=>{
            console.log("SubmitRubricMarking res:",res);
            if(res.result){
                return Promise.resolve(res);    
            }else {
                return Promise.resolve(res);    
            }
        },
        (error)=>{
            console.log(error);
            return Promise.reject();
        }
    )
}

//Get Form Data
function GetAppsRubric(Course,Tmaid){

    const Token=(store.getState().userInfo.token);
    

    console.log("Get Apps Rubric by;Course:"+ Course + "+Tmain:"+Tmaid);
    //Tmaid = "SOFTSKILL1";

    let formBody = [];
    let dataToSend = {token:Token,course:Course,tmaid:Tmaid};
    for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    // console.log("GetAppsRubric formbody:",formBody);
    return fetchService.callbypost(Config.GET_APPS_RUBRIC,
        {
            body: formBody,
        },{}).then(
        (res)=>{
            console.log("GetAppsRubric Result:",res);
            if(res.result){
                //store.dispatch({type:userConstants.SET_USERNAME,payload:email});
                return Promise.resolve(res);    
            }else {
                return Promise.resolve(res);    
            }
        },
        (error)=>{
            console.log(error);
            /*dispatch({
                type: userConstants.LOGOUT_WITHOUT_CLEAR,
                payload:{}
            });*/
            return Promise.reject();
        }
    )
}

function OLELogout(){
    return fetchService.callbyget(Config.OLE_LOGOUT,{cache: 'no-store'}).then(
        (res)=>{
            console.log(res);
            Promise.resolve(res);
        },
        (err)=>{
            console.log(err);
            Promise.resolve(err);
        }
    )
}
//Get Student Status !! Saved Data
function GetStudentStatus(){

    const Token=(store.getState().userInfo.token);
    let Sid = store.getState().userInfo.selectedStudentID;

    // if(Sid.length >8){
    //     if(Sid.includes('s')){
    //         Sid = Sid.replace('s','');
    //     }
    // }
    // else if(Sid.length==8){
    //     if(Sid.includes('s')){
    //         Sid = Utility.convertToUserId(Sid);
    //     }
    // }
    // else if(Sid.length<8){
    //     if(!Sid.includes('s')){
    //         Sid = "s" + Sid;
    //     }
    //     else{
    //         Sid = Utility.convertToUserId(Sid);
    //     }
    // }
    if(!Sid.includes('s')){
        Sid = "s" + Sid;
    }
    if(Sid.length != 8){
        Sid = Sid.substring(0,8);
    }


    let Course = store.getState().userInfo.selectedCourse;
    let Tmaid = store.getState().userInfo.selectedCourseActivityID;
    
    console.log("Get Student Status by;Course:"+ Course + "+Tmain:"+Tmaid + "+StudentID:" + Sid);
    
    //Hardcode = Devlopment Use
    //Tmaid = "SOFTSKILL1";

    let formBody = [];
    let dataToSend = {token:Token,course:Course,tmaid:Tmaid,sid:Sid};
    for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    // console.log("GetStudentStatus formbody:",formBody);
    return fetchService.callbypost(Config.GET_STUDENT_STATUS,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formBody,
        },{}).then(
        (res)=>{
            console.log("GetStudentStatus Result:",res);
            if(res != undefined){
                if(res.result){
                    //store.dispatch({type:userConstants.SET_USERNAME,payload:email});
                    return Promise.resolve(res);    
                }else {
                    return Promise.resolve(res);    
                }
            }
            else{
                return Promise.resolve(res);   
            }

        },
        (error)=>{
            console.log(error);
            /*dispatch({
                type: userConstants.LOGOUT_WITHOUT_CLEAR,
                payload:{}
            });*/
            return Promise.reject();
        }
    )
}

//Get All Student Result 
function GetAllStudentResult(){

    const Token=(store.getState().userInfo.token);
    let Course = store.getState().userInfo.selectedCourse;
    let Tmaid = store.getState().userInfo.selectedCourseActivityID;
    
    console.log("Get All Student Status by;Course:"+ Course + "+Tmain:"+Tmaid);
    
    //Hardcode = Devlopment Use
    //Tmaid = "SOFTSKILL1";

    let formBody = [];
    let dataToSend = {token:Token,course:Course,tmaid:Tmaid};
    for (let key in dataToSend) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(dataToSend[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');
    // console.log("Get All Student Status formbody:",formBody);
    return fetchService.callbypost(Config.GET_ALL_STUDENT_RESULT,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formBody,
        },{}).then(
        (res)=>{
            console.log("Get All Student Result@useraction:",res);
            if(res != undefined){
                if(res.result){
                    store.dispatch({type:'SET_ALLSTUDENTRESULT',payload:res.answers});
                    return Promise.resolve(res);    
                }else {
                    store.dispatch({type:'SET_ALLSTUDENTRESULT',payload:{}});
                    return Promise.resolve(res);    
                }
            }
            else{
                return Promise.resolve(res);   
            }

        },
        (error)=>{
            console.log(error);
            /*dispatch({
                type: userConstants.LOGOUT_WITHOUT_CLEAR,
                payload:{}
            });*/
            return Promise.reject();
        }
    )
}


// Submit Logbook
function SubmitLogBook(
    Startingdate,
    Experience,
    Learningactivities,
    Appendix,
    healthConditions,
    assessmentApplied,
    treatment
    ){

    const Token=(store.getState().userInfo.token);
    let Sid = store.getState().userInfo.selectedStudentID;

    if(!Sid.includes("s")){
        Sid = "s" + Sid;
    }

    if(Sid.length > 8){
        Sid = Sid.substring(0,8);
    }

    let Course = store.getState().userInfo.selectedCourse;
    let Tmaid = store.getState().userInfo.selectedCourseActivityID;
    
    let formBody = [];

    let dataToSend = {}
    let submitUrl='';

    let temphealthConditions="";
    for(let i=0;i<healthConditions.length;i++){
        if(healthConditions[i] != undefined){
            temphealthConditions += healthConditions[i] + "||";
        }
    }

    let tempassessmentApplied="";
    for(let i=0;i<assessmentApplied.length;i++){
        if(assessmentApplied[i] != undefined){
            tempassessmentApplied += assessmentApplied[i] + "||";
        }
    }

    let temptreatment="";
    for(let i=0;i<treatment.length;i++){
        if(treatment[i] != undefined){ 
            temptreatment += treatment[i] + "||";
        }
    }

    console.log("temphealthConditions:",temphealthConditions);
    console.log("tempassessmentApplied:",tempassessmentApplied);
    console.log("temptreatment:",temptreatment);

    dataToSend = {
        token:Token,
        course:Course,
        tmaid:Tmaid,
        sid:Sid,
        Startingdate:Startingdate,
        Experience:Experience,
        Learningactivities:Learningactivities,
        Appendix:Appendix,
        healthConditions:temphealthConditions,
        assessmentApplied:tempassessmentApplied,
        treatment:temptreatment,

    }
    // submitUrl=Config.SUBMIT_RUBRIC_MARKING;
   
    for (let key in dataToSend) {
        // let encodedKey = key;
        // let encodedValue = dataToSend[key];
        let encodedKey = encodeURIComponent(key);
        let encodedValue = encodeURIComponent(dataToSend[key]);

        formBody.push(encodedKey + '=' + encodedValue);
    }

    formBody = formBody.join('&');

    // console.log("SubmitRubricMarking:",formBody);
    // console.log('dataToSend',dataToSend)
    
    return "1";

    return fetchService.callbypost(submitUrl,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formBody,
        },{}).then(
        (res)=>{
            console.log("Submit LogBook res:",res);
            if(res.result){
                return Promise.resolve(res);    
            }else {
                return Promise.resolve(res);    
            }
        },
        (error)=>{
            console.log(error);
            return Promise.reject();
        }
    )
}
